export const fetchRubrics = (resp: any) => ({
  type: 'FETCH_RUBRICS',
  payload: resp,
});

export default {
  fetchRubrics,
};
